// Asheville, NC geographic boundary configuration
// Defines the allowed area for food truck pins

// Center of Asheville
export const ASHEVILLE_CENTER = {
  lat: 35.5951,
  lng: -82.5515
};

// Radius in kilometers (approximately covers Asheville metro area)
export const ALLOWED_RADIUS_KM = 15;

// Bounding box for quick checks (approximate Asheville area)
export const ASHEVILLE_BOUNDS = {
  north: 35.7000,
  south: 35.4500,
  east: -82.3500,
  west: -82.7500
};

// Check if a point is within the allowed radius
export function isWithinAllowedArea(lat, lng) {
  const distance = getDistanceFromCenter(lat, lng);
  return distance <= ALLOWED_RADIUS_KM;
}

// Calculate distance from center in kilometers using Haversine formula
export function getDistanceFromCenter(lat, lng) {
  const R = 6371; // Earth's radius in km
  const dLat = toRad(lat - ASHEVILLE_CENTER.lat);
  const dLng = toRad(lng - ASHEVILLE_CENTER.lng);
  const a = 
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(ASHEVILLE_CENTER.lat)) * Math.cos(toRad(lat)) *
    Math.sin(dLng / 2) * Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

function toRad(deg) {
  return deg * (Math.PI / 180);
}
